import { BigNumber } from '@ethersproject/bignumber'
import { useCallback, useState } from 'react'
import { getSecurityTokenContract } from 'utils'

const bigNumberToNumber = (value: BigNumber): number => {
  try {
    return value.toNumber()
  } catch (e) {
    return Number.MAX_SAFE_INTEGER
  }
}

export const useSecurityTokenState = () => {
  const [
    { availableLimit, ableToTradeSecurityToken, loadingSecurityState, leftTransactionCountLimit },
    setSecurityState,
  ] = useState({
    availableLimit: 0,
    leftTransactionCountLimit: 0,
    ableToTradeSecurityToken: false,
    loadingSecurityState: false,
  })

  const valudateSecurityTokenState = useCallback(
    (securityToken, library, account) => {
      if (!loadingSecurityState) {
        setSecurityState({
          availableLimit: 0,
          leftTransactionCountLimit: 0,
          ableToTradeSecurityToken: false,
          loadingSecurityState: true,
        })
      }

      if (securityToken && library && account) {
        const securityTokenContract = getSecurityTokenContract(securityToken, library, account)
        Promise.all([
          securityTokenContract.getAllowedToTransfer(account),
          securityTokenContract.isWhitelistedAddress(account),
          securityTokenContract.getLeftTransactionCountLimit(account),
        ])
          .then((result) => {
            setSecurityState({
              availableLimit: bigNumberToNumber(result[0]),
              leftTransactionCountLimit: bigNumberToNumber(result[2]),
              ableToTradeSecurityToken: result[1],
              loadingSecurityState: false,
            })
          })
          .catch((e) => {
            setSecurityState({
              availableLimit: 0,
              leftTransactionCountLimit: 0,
              ableToTradeSecurityToken: false,
              loadingSecurityState: false,
            })
          })
      } else {
        setSecurityState({
          availableLimit: 0,
          leftTransactionCountLimit: 0,
          ableToTradeSecurityToken: false,
          loadingSecurityState: false,
        })
      }
    },
    [availableLimit, ableToTradeSecurityToken, loadingSecurityState],
  )

  return {
    valudateSecurityTokenState,
    availableLimit,
    ableToTradeSecurityToken,
    loadingSecurityState,
    leftTransactionCountLimit,
  }
}

export default useSecurityTokenState
